
import Framework from '@geek/yum-freight-framework'
import YunIcon from '@yld/yun-icon'
import './assets/element.scss'
import Vue from 'vue'
import { initProjectI18n } from './lang'
import goFreightEnglishNameMixin from './mixins/goFreightEnglishName'

const serverConfig = require('../serverConfig.json')

Vue.prototype.$eventBus = new Vue()
initProjectI18n()
Vue.mixin(goFreightEnglishNameMixin)
const app = new Framework({
  serverConfig
})

app.use(YunIcon)
app.start()
